import { IconButton } from "@material-ui/core";
import i18next from "../../../assets/i18n/i18n";
import React, { MouseEventHandler } from "react";
import "../buttons.scss";

type Props = {
    onClose: MouseEventHandler;
};

const ButtonCancel = ({ onClose }: Props): React.ReactElement => {
    return (
        <IconButton id="BtnCancel" className="btn secondary-btn" onClick={onClose}>
            <p className="btn-label">{i18next.t("Buttons.Cancel")}</p>
        </IconButton>
    );
};

export default ButtonCancel;
